import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
}

const variantClasses: Record<Variant, string> = {
  primary:
    'bg-[rgb(var(--np-accent))] hover:bg-[rgb(var(--np-accent-muted))] text-white font-semibold rounded-md px-4 py-2 text-sm uppercase tracking-wider transition-all',
  secondary:
    'bg-[rgb(var(--np-raised))] hover:bg-[rgb(var(--np-overlay))] text-[rgb(var(--np-tx-secondary))] border border-[rgb(var(--np-border))] rounded-md px-3 py-1.5 text-xs font-medium transition-colors',
  ghost:
    'p-2 hover:bg-[rgb(var(--np-raised))] rounded-lg text-[rgb(var(--np-tx-muted))] hover:text-[rgb(var(--np-tx-secondary))] transition-colors',
}

export function Button({ variant = 'primary', className = '', ...props }: ButtonProps) {
  return (
    <button
      className={`${variantClasses[variant]} disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    />
  )
}
